module.exports = __webpack_public_path__ + "static/entreaide-bdc142e5b5b95823f33f44580ae5f80e.svg";